<template>
  <el-container>
    <el-aside id="sidebar">
      <el-menu :default-active="activeMenu" unique-opened router background-color="#ffffff"
                text-color="#000111" active-text-color="#fdc558" >
<!--        background-color="#161616"-->
        <el-submenu :index="menu.menusRow.menuId + ''" v-for="menu in menus" v-if="menu.menusRow.menuId!==8" class="submenu">
          <template slot="title">
            <i :class="menu.menusRow.icon"></i>
            <span>{{ menu.menusRow.menuName }}</span>
          </template>
          <el-menu-item v-for="child in menu.children" :index="child.menuRouter"><i :class="child.icon"></i>
            <span>{{ child.menuName }}</span>
          </el-menu-item>
        </el-submenu>
<!--        <el-menu-item v-if="$store.getters['right/getRole']==='manager'||$store.getters['right/getRole']==='analyzer'">-->
<!--          <i class="iconfont icon-xitonggongneng1"></i>-->
<!--          <a style="color: #000111;text-decoration: none;width: 100%" href="https://gitee.com/vg_soft_team_rep/public_bz_amplicon"-->
<!--             target="_blank">命令行程序</a>-->
<!--        </el-menu-item>-->
        <el-menu-item v-if="$store.getters['right/getRole']==='manager'||$store.getters['right/getRole']==='analyzer'" :index="'/command'">
          <i class="iconfont icon-xitonggongneng1"></i>
          <span>命令行程序</span>
        </el-menu-item>
        <el-menu-item v-if="$store.getters['right/getRole']==='manager'" :index="'/questionnaire'"><i
          class="iconfont icon-xiangqing"></i>
          <span>调查问卷</span>
        </el-menu-item>
        <el-menu-item v-if="$store.getters['right/getRole']!=='manager'&&showServery" :index="'/display'"><i
          class="iconfont icon-xiangqing"></i>
          <span>调查问卷</span>
        </el-menu-item>
<!--        <el-menu-item index="/log"><i class="iconfont icon-rizhi"></i>-->
<!--          <span>更新日志</span>-->
<!--        </el-menu-item>-->
      </el-menu>
    </el-aside>
    <el-container>
      <el-main class="m-content-display">
        <div class="m-router-view">
          <transition name="nodebook" mode="out-in">
            <router-view/>
          </transition>
        </div>
        <el-footer style="margin-bottom: 0px;height: 20px">
          <Footers></Footers>
        </el-footer>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>


import Footers from "@/components/Footers";

export default {
  components: {Footers},
  data() {
    return {
      menus: [],
      showServery: false,
    }
  },

  mounted() {
    this.getMenu()
    this.$http.get("/survey/get").then(res => {
      if (res.code === 200) {
        if (JSON.stringify(res.data) !== "{}") {
          this.showServery = true
        }
      }
    })
  },
computed:{
  activeMenu() {
    const route = this.$route;
    const { meta, path } = route;
    if (meta.activeMenu) {
      return meta.activeMenu;
    }
    return path;
  },
},
  methods: {
    async getMenu() {
      const {data: menus} = await this.$http.get('menu')
      this.menus = menus
    },

  }
}
</script>

<style scoped>
#sidebar {
  background-color: #ffffff;
}

/*#sidebar .el-menu .el-submenu li {*/
/*  background-color: #a62e19 !important;*/
/*}*/

/*#sidebar .el-menu .el-submenu li:hover {*/
/*  background-color: #3f9dfe !important;*/
/*}*/
/deep/.is-active{
  background-color: #fdf5e2 !important;
}
::v-deep.el-menu-item:hover{
  background-color: #fdf5e2 !important;
}
::v-deep.el-submenu__title:hover {
  /*color:white!important;*/
  background: #eee6d5 !important;
}
/deep/.el-submenu__title:hover {
  /*color:white!important;*/
  background: #fdf5e2!important;
}
/deep/.el-menu--inline li {
  /*color:white!important;*/
  background: #f6f7f8 !important;
  font-size: 14px;
}
.el-header-col-right {
  display: flex;
  align-items: center;
  justify-content: end;
}

.el-dropdown {
  color: #fff;
}

.header-name {
  display: flex;
  align-items: center;
  height: 100%;
}

.el-row,
.el-col {
  height: 100%;
}


.header-name img {
  width: 40px;
  margin: 0 20px;
}

.el-header {
  background-color: #123049;
  color: #fff;
}


.el-aside {
  width: 230px !important;
  height: 100%;
  background-color: #fdfdfe;
}

.el-container {
  height: 100%;
}

.el-menu {
  border: 0;
}

.m-router-view {
  flex: 1;
}

.m-content-display {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>
